<template>
  <div>

    <div class="d-flex mt-2">
      <feather-icon icon="ToolIcon" size="19"/>
      <h4 class="mb-0 ml-50">
        {{ $t('FIELD_SERVICES_INSTALLATION_DETAILS')}}
      </h4>
    </div>

    <b-row class="mt-2" v-if="$store.getters['fieldServices.installation.form/fields'].includes('customer_id')">
      <b-col md="6">
        <b-form-group :label="$t('FIELD_SERVICES_CUSTOMER_LABEL')">
          <v-select 
            :disabled="$store.getters['fieldServices.installation.form/isReadOnly']"
            :placeholder="$t('FIELD_SERVICES_CUSTOMER_PLACEHOLDER')" 
            @input="(value)=> $store.commit('fieldServices.installation.form/updateCustomerId', {value})"
            :value="$store.getters['fieldServices.installation.form/customer_id']"
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
            :getOptionLabel="customer => customer.name" 
            :options="$store.getters['fieldServices.installation.form/customerOptions']" 
            :reduce="customer => customer.id" 
          />
          <small v-if="('customer_id' in $store.getters['fieldServices.installation.form/errors'])" class="text-danger">
            {{ $t($store.getters['fieldServices.installation.form/errors']['customer_id'][0]) }}
          </small>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-2" v-if="$store.getters['fieldServices.installation.form/fields'].includes('contract_id')">
      <b-col md="6">
        <b-form-group :label="$t('FIELD_SERVICES_CONTRACT_LABEL')">
          <v-select 
            :disabled="$store.getters['fieldServices.installation.form/isReadOnly']"
            :placeholder="$t('FIELD_SERVICES_CONTRACT_PLACEHOLDER')" 
            @input="(value)=> $store.commit('fieldServices.installation.form/updateContractId', {value})"
            :value="$store.getters['fieldServices.installation.form/contract_id']"
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
            :getOptionLabel="contract => contract.name" 
            :options="$store.getters['fieldServices.installation.form/contractOptions']" 
            :reduce="contract => contract.id"
          />
          <small v-if="('contract_id' in $store.getters['fieldServices.installation.form/errors'])" class="text-danger">
            {{ $t($store.getters['fieldServices.installation.form/errors']['contract_id'][0]) }}
          </small>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-2" v-if="$store.getters['fieldServices.installation.form/fields'].includes('technician_id')">
      <b-col md="6">
        <b-form-group :label="$t('FIELD_SERVICES_TECHNICIAN_LABEL')">
          <v-select 
            :disabled="$store.getters['fieldServices.installation.form/isReadOnly']"
            :placeholder="$t('FIELD_SERVICES_TECHNICIAN_PLACEHOLDER')" 
            @input="(value)=> $store.commit('fieldServices.installation.form/updateTechnicianId', {value})"
            :value="$store.getters['fieldServices.installation.form/technician_id']"
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
            :getOptionLabel="customer => customer.name" 
            :options="$store.getters['fieldServices.installation.form/technicianOptions']" 
            :reduce="customer => customer.id" 
          />
          <small v-if="('technician_id' in $store.getters['fieldServices.installation.form/errors'])" class="text-danger">
            {{ $t($store.getters['fieldServices.installation.form/errors']['technician_id'][0]) }}
          </small>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-2" v-if="$store.getters['fieldServices.installation.form/fields'].includes('datetime')">
      <b-col md="6">
        <b-form-group :label="$t('FIELD_SERVICES_DATETIME_LABEL')">
            <flat-pickr 
              :disabled="$store.getters['fieldServices.installation.form/isReadOnly']"
              :placeholder="$t('FIELD_SERVICES_DATETIME_PLACEHOLDER')" 
              @input="(value)=> $store.commit('fieldServices.installation.form/updateDatetime', {value})"
              :value="$store.getters['fieldServices.installation.form/datetime']"
              :config="$store.getters['fieldServices.installation.form/datetimeConfig']"
              class="form-control" 
            />
          <small v-if="('datetime' in $store.getters['fieldServices.installation.form/errors'])" class="text-danger">
            {{ $t($store.getters['fieldServices.installation.form/errors']['datetime'][0]) }}
          </small>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-2" v-if="$store.getters['fieldServices.installation.form/fields'].includes('product_type')">
      <b-col md="6">
        <b-form-group :label="$t('FIELD_SERVICES_PRODUCT_TYPE_LABEL')">
          <v-select 
            :disabled="$store.getters['fieldServices.installation.form/isReadOnly']"
            :placeholder="$t('FIELD_SERVICES_PRODUCT_TYPE_PLACEHOLDER')" 
            @input="(value)=> {
              $store.commit('fieldServices.installation.form/updateProductType', {value})
              $store.commit('fieldServices.installation.form/resetProductSubtype')
            }"
            :value="$store.getters['fieldServices.installation.form/product_type']"
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
            :options="$store.getters['fieldServices.installation.form/productTypeOptions']" 
          />
          <small v-if="('product_type' in $store.getters['fieldServices.installation.form/errors'])" class="text-danger">
            {{ $t($store.getters['fieldServices.installation.form/errors']['product_type'][0]) }}
          </small>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-2" v-if="$store.getters['fieldServices.installation.form/fields'].includes('product_subtype')">
      <b-col md="6">
        <b-form-group :label="$t('FIELD_SERVICES_PRODUCT_SUB_TYPE_LABEL')">
          <v-select 
            :disabled="$store.getters['fieldServices.installation.form/isReadOnly']"
            :placeholder="$t('FIELD_SERVICES_PRODUCT_SUB_TYPE_PLACEHOLDER')"
            @input="(value)=> $store.commit('fieldServices.installation.form/updateProductSubtype', {value})"
            :value="$store.getters['fieldServices.installation.form/product_subtype']"
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
            :options="$store.getters['fieldServices.installation.form/productSubtypeOptions']" 
          />
          <small v-if="('product_subtype' in $store.getters['fieldServices.installation.form/errors'])" class="text-danger">
            {{ $t($store.getters['fieldServices.installation.form/errors']['product_subtype'][0]) }}
          </small>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-2" v-if="$store.getters['fieldServices.installation.form/fields'].includes('has_pto')">
      <b-col md="6">
        <b-form-group :label="$t('FIELD_SERVICES_HAS_PTO_LABEL')">
          <b-form-checkbox 
            :disabled="$store.getters['fieldServices.installation.form/isReadOnly']"
            v-model="has_pto"
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
            switches
          />
          <small v-if="('has_pto' in $store.getters['fieldServices.installation.form/errors'])" class="text-danger">
            {{ $t($store.getters['fieldServices.installation.form/errors']['has_pto'][0]) }}
          </small>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-2" v-if="$store.getters['fieldServices.installation.form/fields'].includes('unique_id')">
      <b-col md="6">
        <b-form-group :label="$t('FIELD_SERVICES_UNIQUE_ID_LABEL')">
          <b-form-input 
            :disabled="$store.getters['fieldServices.installation.form/isReadOnly']"
            @input="(value)=> $store.commit('fieldServices.installation.form/updateUniqueId', {value})"
            :value="$store.getters['fieldServices.installation.form/unique_id']"
            :placeholder="$t('FIELD_SERVICES_UNIQUE_ID_PLACEHOLDER')" 
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
          />
          <small v-if="('unique_id' in $store.getters['fieldServices.installation.form/errors'])" class="text-danger">
            {{ $t($store.getters['fieldServices.installation.form/errors']['unique_id'][0]) }}
          </small>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-2" v-if="$store.getters['fieldServices.installation.form/fields'].includes('sim_id')">
      <b-col md="6">
        <b-form-group :label="$t('FIELD_SERVICES_SIM_ID_LABEL')">
          <b-form-input 
            :disabled="$store.getters['fieldServices.installation.form/isReadOnly']"
            @input="(value)=> $store.commit('fieldServices.installation.form/updateSimId', {value})"
            :value="$store.getters['fieldServices.installation.form/sim_id']"
            :placeholder="$t('FIELD_SERVICES_SIM_ID_PLACEHOLDER')" 
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
          />
          <small v-if="('sim_id' in $store.getters['fieldServices.installation.form/errors'])" class="text-danger">
            {{ $t($store.getters['fieldServices.installation.form/errors']['sim_id'][0]) }}
          </small>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-2" v-if="$store.getters['fieldServices.installation.form/fields'].includes('vehicle_category')">
      <b-col md="6">
        <b-form-group :label="$t('FIELD_SERVICES_VEHICLE_CATEGORY_LABEL')">
          <v-select 
            :disabled="$store.getters['fieldServices.installation.form/isReadOnly']"
            :placeholder="$t('FIELD_SERVICES_VEHICLE_CATEGORY_PLACEHOLDER')" 
            @input="(value)=> $store.commit('fieldServices.installation.form/updateVehicleCategory', {value})"
            :value="$store.getters['fieldServices.installation.form/vehicle_category']"
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
            :options="$store.getters['fieldServices.installation.form/vehicleCategoryOptions']" 
          />
          <small v-if="('vehicle_category' in $store.getters['fieldServices.installation.form/errors'])" class="text-danger">
            {{ $t($store.getters['fieldServices.installation.form/errors']['vehicle_category'][0]) }}
          </small>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-2" v-if="$store.getters['fieldServices.installation.form/fields'].includes('plate_number')">
      <b-col md="6">
        <b-form-group :label="$t('FIELD_SERVICES_PLATE_NUMBER_LABEL')">
          <b-form-input 
            :disabled="$store.getters['fieldServices.installation.form/isReadOnly']"
            @input="(value)=> $store.commit('fieldServices.installation.form/updatePlateNumber', {value})"
            :value="$store.getters['fieldServices.installation.form/plate_number']"
            :placeholder="$t('FIELD_SERVICES_PLATE_NUMBER_PLACEHOLDER')" 
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
          />
          <small v-if="('plate_number' in $store.getters['fieldServices.installation.form/errors'])" class="text-danger">
            {{ $t($store.getters['fieldServices.installation.form/errors']['plate_number'][0]) }}
          </small>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-2" v-if="$store.getters['fieldServices.installation.form/fields'].includes('plate_right_letter')">
      <b-col md="6">
        <b-form-group :label="$t('FIELD_SERVICES_PLATE_RIGHT_LETTER_LABEL')">
          <b-form-input 
            :disabled="$store.getters['fieldServices.installation.form/isReadOnly']"
            @input="(value)=> $store.commit('fieldServices.installation.form/updatePlateRightLetter', {value})"
            :value="$store.getters['fieldServices.installation.form/plate_right_letter']"
            :placeholder="$t('FIELD_SERVICES_PLATE_RIGHT_LETTER_PLACEHOLDER')" 
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
          />
          <small v-if="('plate_right_letter' in $store.getters['fieldServices.installation.form/errors'])" class="text-danger">
            {{ $t($store.getters['fieldServices.installation.form/errors']['plate_right_letter'][0]) }}
          </small>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-2" v-if="$store.getters['fieldServices.installation.form/fields'].includes('plate_middle_letter')">
      <b-col md="6">
        <b-form-group :label="$t('FIELD_SERVICES_PLATE_MIDDLE_LETTER_LABEL')">
          <b-form-input 
            :disabled="$store.getters['fieldServices.installation.form/isReadOnly']"
            @input="(value)=> $store.commit('fieldServices.installation.form/updatePlateMiddleLetter', {value})"
            :value="$store.getters['fieldServices.installation.form/plate_middle_letter']"
            :placeholder="$t('FIELD_SERVICES_PLATE_MIDDLE_LETTER_PLACEHOLDER')" 
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
          />
          <small v-if="('plate_right_letter' in $store.getters['fieldServices.installation.form/errors'])" class="text-danger">
            {{ $t($store.getters['fieldServices.installation.form/errors']['plate_middle_letter'][0]) }}
          </small>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-2" v-if="$store.getters['fieldServices.installation.form/fields'].includes('plate_left_letter')">
      <b-col md="6">
        <b-form-group :label="$t('FIELD_SERVICES_PLATE_LEFT_LETTER_LABEL')">
          <b-form-input 
            :disabled="$store.getters['fieldServices.installation.form/isReadOnly']"
            @input="(value)=> $store.commit('fieldServices.installation.form/updatePlateLeftLetter', {value})"
            :value="$store.getters['fieldServices.installation.form/plate_left_letter']"
            :placeholder="$t('FIELD_SERVICES_PLATE_LEFT_LETTER_PLACEHOLDER')" 
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
          />
          <small v-if="('plate_right_letter' in $store.getters['fieldServices.installation.form/errors'])" class="text-danger">
            {{ $t($store.getters['fieldServices.installation.form/errors']['plate_left_letter'][0]) }}
          </small>
        </b-form-group>
      </b-col>
    </b-row>
    
  </div>
</template>

<script>

import store from '@/store'

import { 
  BButton, 
  BCol, 
  BForm, 
  BFormGroup,
  BFormCheckbox,
  BFormInput, 
  BInputGroup, 
  BRow 
} from 'bootstrap-vue'

import vSelect from 'vue-select'

import { computed } from '@vue/composition-api'

import flatPickr from 'vue-flatpickr-component'

export default {
  components: { 
    BRow, 
    BCol, 
    BFormGroup,
    BFormCheckbox,
    BFormInput, 
    BInputGroup, 
    BForm, 
    BButton, 
    vSelect,
    flatPickr
  },
  setup( props, { root }) {

    store.dispatch('fieldServices.installation.form/fetchOptions')

    return {
      has_pto:computed({
        get(){
          return store.getters['fieldServices.installation.form/has_pto']
        },
        set(value){
          store.commit('fieldServices.installation.form/updateHasPto', {value})
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
